/**************************************************
 * Nombre:       Pdf_Recibo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Document, Font, Image, Page, StyleSheet, Text, View} from '@react-pdf/renderer';
import f500 from '../Recursos/Montserrat-Regular.ttf'
import f600 from '../Recursos/Montserrat-Medium.ttf'
import f700 from '../Recursos/Montserrat-Bold.ttf'
import {formatoMoneda} from "../Utilidades/formatoMoneda";
import {VALORENVIOGRATIS} from "../../Constantes";
import {obtenerValorTotal} from "../../Modulo_Envios_2026/Funciones/obtenerValorTotal";
import {formatoFecha} from "../../Modulo_Carrito_Lateral/Utilidades/formatoFecha";

const Pdf_Recibo = ({logo, pedido, datos}) => {
    Font.register({family: '500', src: f500})
    Font.register({family: '600', src: f600})
    Font.register({family: '700', src: f700})


    const styles = StyleSheet.create({
        page: {
            flexDirection: 'row',
            backgroundColor: '#FFF',
            padding: 28
        },
        gitc: {
            justifyContent: 'center',
            flexDirection: 'row',
            width: '100%'
        },
        git: {
            justifyContent: 'flex-start',
            flexDirection: 'row',
            width: '100%'
        },
        gitg: {
            justifyContent: 'flex-end',
            flexDirection: 'row',
            width: '100%'
        },
        texto: {
            fontSize: 8,
            fontFamily: '600'
        },
        textoL: {
            fontSize: 8,
            fontFamily: '500'
        },
        textoGT: {
            fontSize: 10,
            fontFamily: '700'
        },
        textoG: {
            fontSize: 10,
            fontFamily: '500'
        },


    });

    const Titulos = ({derecha, izquierda}) => {
        return (
            <View style={styles.gitc}>
                <View style={{...styles.git, width: '50%'}}>
                    <Text style={styles.textoGT}>{derecha}</Text>
                </View>
                <View style={{...styles.git, width: '50%', justifyContent: 'flex-end'}}>
                    <Text style={styles.textoGT}>{izquierda}</Text>
                </View>
            </View>
        )
    }

    const Datos = ({derecha, izquierda}) => {
        return (
            <View style={styles.gitc}>
                <View style={{...styles.git, width: '50%'}}>
                    <Text style={styles.textoG}>{derecha}</Text>
                </View>
                <View style={{...styles.git, width: '50%', justifyContent: 'flex-end'}}>
                    <Text style={styles.textoG}>{izquierda}</Text>
                </View>
            </View>
        )
    }

    const Items = ({items = []}) => {

        return items.map((it, index) => {
            return (
                <View style={styles.gitc}>
                    <View style={{...styles.git, width: '50%'}}>
                        <Text style={styles.textoG}>{`( ${it.cantidad} ) ${it.nombre}`}</Text>
                    </View>
                    <View style={{...styles.git, width: '50%', justifyContent: 'flex-end'}}>
                        <Text style={styles.textoG}>{formatoMoneda(it.cantidad * it.valor)}</Text>
                    </View>
                </View>
            )
        })
    }


    return (
        <Document>
            <Page size={[320, 600]} style={styles.page}>

                <View style={{justifyContent: 'flex-start', flexDirection: 'column', width: '100%'}}>

                    <View style={styles.gitc}>
                        <Image src={logo} style={{width: 150, height: 60}}/>
                    </View>

                    <View style={{...styles.gitc, marginTop: 20}}>
                        <Text style={styles.textoG}>NARIÑO SOUVENIRS</Text>
                    </View>

                    <View style={{...styles.gitc, marginTop: 0}}>
                        <Text style={styles.textoG}>901702737-0</Text>
                    </View>
                    <View style={{...styles.gitc, marginTop: 0}}>
                        <Text style={styles.textoG}>Plaza de Nariño Cra 25# 18-45</Text>
                    </View>

                    <View style={{...styles.gitc, marginTop: 0}}>
                        <Text style={styles.textoG}>+57 318 327 0023</Text>
                    </View>

                    <View style={{...styles.gitc, marginTop: 0}}>
                        <Text style={styles.textoG}>hola@narinosouvenirs.com</Text>
                    </View>

                    <View style={{...styles.git, marginTop: 20}}>
                        <Datos derecha={'Numero de pedido:'} izquierda={datos.consecutivo}/>
                    </View>

                    <View style={{...styles.git, marginTop: 0}}>
                        <Datos derecha={'Fecha de Pago'} izquierda={formatoFecha(datos.fecha)}/>
                    </View>

                    <View style={{...styles.git, marginTop: 10}}>
                        <Titulos derecha={'ID Transaccion'} izquierda={datos.idTransaccion}/>
                    </View>

                    <View style={styles.git}>
                        <Titulos derecha={'Estado'} izquierda={datos.estadoPago}/>
                    </View>


                    <View style={styles.git}>
                        <Datos derecha={'Id Pedido'} izquierda={pedido.idPedido}/>
                    </View>

                    <View style={styles.git}>
                        <Datos derecha={'Nombre: '} izquierda={pedido.nombre}/>
                    </View>

                    <View style={styles.git}>
                        <Datos derecha={'Metodo: '} izquierda={pedido.metodo}/>
                    </View>

                    <View style={styles.git}>
                        <Datos derecha={'Mensaje: '} izquierda={pedido.mensaje}/>
                    </View>


                    <View style={{...styles.gitc, marginTop: 20}}>
                        <Text
                            style={styles.textoG}>*******************************************************************</Text>
                    </View>


                    <View style={styles.git}>
                        <Titulos derecha={'Descripcion'} izquierda={'Valor'}/>
                    </View>

                    <View style={{...styles.git, flexDirection: 'column'}}>
                        <Items items={pedido.productos}/>
                    </View>

                    <View style={{...styles.gitc, marginTop: 6}}>
                        <Text
                            style={styles.textoG}>*******************************************************************</Text>
                    </View>


                        <View style={styles.git}>
                            <Titulos derecha={'Subtotal'}
                                     izquierda={formatoMoneda(obtenerValorTotal(pedido.productos))}/>
                        </View>



                    {pedido.valorDescuento && pedido.valorDescuento > 0 &&
                        <View style={styles.git}>
                            <Titulos derecha={'Valor Descuento'}
                                     izquierda={`- ${formatoMoneda(pedido.valorDescuento)}`}/>
                        </View>

                    }

                    <View style={styles.git}>
                        <Titulos derecha={datos.valorPagado >= VALORENVIOGRATIS ? `Envio Gratis ${pedido.ciudad}` : `Envio ${pedido.ciudad}`}
                                 izquierda={datos.valorPagado >= VALORENVIOGRATIS ? '' : formatoMoneda(pedido.valorEnvio)}/>
                    </View>



                    <View style={{...styles.gitc, marginTop: 6}}>
                        <Text
                            style={styles.textoG}>*******************************************************************</Text>
                    </View>

                    <View style={styles.git}>
                        <Titulos derecha={'Total Pagado'} izquierda={formatoMoneda(datos.valor)}/>
                    </View>

                    <View style={{...styles.gitc, marginTop: 40}}>
                        <Text style={styles.textoG}>¡Muchas gracias por tu compra!</Text>
                    </View>


                </View>
            </Page>
        </Document>
    )

}
export default Pdf_Recibo    